import React from 'react';
import clsx from 'clsx';
import Icon from './Icon';

import styles from './Intro.module.scss';
import { SHOW_TITLE } from '../api/portletConfiguration';

export default function Info({dataSrc}) {

	return (
		<div className={styles.intro}>
			{ SHOW_TITLE &&
			<>
				<Icon className={styles.icon} icon="cerca_officine.svg" size="x-large"></Icon> 
				<h2 className={styles.introTitle}>
					Cerca {dataSrc ? dataSrc.label : null}
				</h2>
				<p className={styles.introSummary}>
					Scopri tutti i nostri centri convenzionati.
				</p>
			</>
			}
		</div>
	);
}
